import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=5a535a46&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
import style0 from "./Principal.vue?vue&type=style&index=0&id=5a535a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a535a46",
  null
  
)

export default component.exports